import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  ThreeDots,
  Periodo,
  Loading,
  ConfirmDialog,
  Badge,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useUtilizacoes, { LOAD_MESSAGE, MENU_ITEMS } from './UtilizacoesTomadaHook'
import UtilizacaoModal from './UtilizacaoModal/UtilizacaoModal'
import {
  parseToMysqlFormatWithTime00,
  parseToMysqlFormatWithTime23,
} from '../../../../services/util/date.service'
import { urlReportUtilizacaoTomadaTicket } from '../../../../services/api/routes/patio.routes'
import parseMovBalancaStatus from '../../../../constants/mov-balanca-status'

function UtilizacoesTomada({ selectedTp, dispatch, history }) {
  const { state, localDispatch } = useUtilizacoes()
  const [isSearching, setIsSearching] = useState(false)

  // init quando o TP mudar
  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  // loading box
  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.INITIAL_GET:
        dispatch(showLoadingBox('Carregando utilizações de tomadas', 'Aguarde...'))
        localDispatch
          .getUtilizacoes({
            tp_id: state.selectedTp,
            pInicial: parseToMysqlFormatWithTime00(state.periodo.inicial),
            pFinal: parseToMysqlFormatWithTime23(state.periodo.final),
          })
          .finally(() => dispatch(hideLoadingBox()))
        break
      default:
        break
    }
  }, [state.loadingMessage, state.selectedTp])

  useEffect(() => {
    if (state.errorMessage) dispatch(showMessageBox(null, state.errorMessage))
  }, [state.errorMessage])

  const header = useMemo(
    () => (
      <CustomDataTableHeader
        value={state.globalFilter}
        onChange={localDispatch.onGlobalFilterChange}
      />
    ),
    [state.globalFilter],
  )

  const onPesquisar = async (pIniDate, pFinDate) => {
    try {
      setIsSearching(true)
      await localDispatch.onPesquisar({
        tp_id: selectedTp,
        pInicial: parseToMysqlFormatWithTime00(pIniDate),
        pFinal: parseToMysqlFormatWithTime23(pFinDate),
      })
    } finally {
      setIsSearching(false)
    }
  }

  const actionTemplate = utl => {
    return (
      <ThreeDots
        items={MENU_ITEMS}
        onClick={async item => {
          if (item === MENU_ITEMS[0]) {
            // 1. Editar
            if (utl.status === 'Finalizada') {
              dispatch(
                showMessageBox(
                  null,
                  'Utilização da tomada já finalizada, não pode mais ser editada.',
                ),
              )
              return
            }
            localDispatch.onRowClick(utl)
          } else if (item === MENU_ITEMS[1]) {
            // 2. Finalizar Utilização
            if (utl.status === 'Finalizada') {
              dispatch(showMessageBox(null, 'Utilização da tomada já está finalizada.'))
              return
            }
            localDispatch.onConfirmFinalizarOpen(utl)
          } else if (item === MENU_ITEMS[2]) {
            // 3. Emitir Ticket
            if (utl.status !== 'Finalizada') {
              dispatch(showMessageBox(null, 'Finalize a utilização para poder emitir ticket'))
              return
            }
            const url = urlReportUtilizacaoTomadaTicket(utl.id)
            window.open(url, '_blank')
          }
        }}
      />
    )
  }

  const formatDateBR = iso => {
    if (!iso) return ''
    const d = new Date(iso)
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const yyyy = d.getFullYear()
    return `${dd}/${mm}/${yyyy}`
  }

  // helpers
  const dtInTemplate = utl =>
    utl.data_inicial
      ? `${formatDateBR(utl.data_inicial)} ${(utl.hora_inicial || '').substring(0, 5)}`
      : ''
  const dtOutTemplate = utl =>
    utl.data_final
      ? `${formatDateBR(utl.data_final)} ${(utl.hora_final || '').substring(0, 5)}`
      : ''

  return (
    <>
      <PageHeader>9.4 - Utilização - Tomadas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          showBtnNovo={!!selectedTp}
          onVoltar={history.goBack}
        >
          <Periodo
            btnEnabled={!!selectedTp}
            onPesquisar={onPesquisar}
            periodoInicial={state.periodo.inicial}
            periodoFinal={state.periodo.final}
            isLoading={isSearching}
          />

          {state.isLoadingTable ? (
            <div className="text-center" style={{ marginTop: 20 }}>
              <Loading />
            </div>
          ) : (
            <DataTable
              style={{ marginTop: 10 }}
              header={header}
              value={state.movs}
              paginator
              rows={15}
              globalFilter={state.globalFilter}
            >
              <Column field="id" header="Código" style={tableCellCentered()} />
              <Column field="tomada_referencia" header="Tomada" />
              <Column field="placa" header="Placa" style={tableCellCentered()} />
              <Column field="motorista" header="Motorista" />
              <Column field="company_name" header="Empresa" />
              <Column header="Entrada" body={dtInTemplate} style={tableCellCentered()} />
              <Column header="Saída" body={dtOutTemplate} style={tableCellCentered()} />
              <Column
                field="status"
                header="Status"
                style={tableCellCentered(170)}
                body={utl => {
                  const status = parseMovBalancaStatus(utl.status)
                  return <Badge color={status.color}>{status.label}</Badge>
                }}
                bodyStyle={tableCellCentered()}
              />
              <Column header="Menu" body={actionTemplate} style={tableCellCentered()} />
            </DataTable>
          )}
        </CustomPanel>
      </div>

      <UtilizacaoModal
        show={state.modal.show}
        data={state.modal.data}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        selectedTp={selectedTp}
        tomadas={state.tomadas}
      />

      <ConfirmDialog
        isVisible={state.modalConfirmFinalize.show}
        title="Atenção"
        okLabel="Sim"
        cancelLabel="Não"
        content={
          <span>
            Ao Finalizar não será mais possível editar essa utilização.
            <br />
            A tomada utilizada voltará a ficar disponível!
            <br />
            Prosseguir?
          </span>
        }
        onCancelar={localDispatch.onConfirmFinalizarClose}
        onOk={async () => {
          localDispatch.onConfirmFinalizarClose()
          try {
            dispatch(showLoadingBox('Finalizando utilização', 'Aguarde...'))
            await localDispatch.onFinalizar(state.modalConfirmFinalize.data.id)
            dispatch(showMessageBox('Utilização finalizada com sucesso.', null))
          } catch (e) {
            dispatch(showMessageBox(null, e && e.message ? e.message : String(e)))
          } finally {
            dispatch(hideLoadingBox())
          }
        }}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(UtilizacoesTomada))
